"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.alertDialog = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const Dialog_1 = __importDefault(require("@material-ui/core/Dialog"));
const DialogTitle_1 = __importDefault(require("@material-ui/core/DialogTitle"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent"));
const DialogContentText_1 = __importDefault(require("@material-ui/core/DialogContentText"));
const DialogActions_1 = __importDefault(require("@material-ui/core/DialogActions"));
const react_modal_promise_1 = require("react-modal-promise");
const Modal = ({ title, text, isOpen, onResolve }) => {
    const onClose = () => onResolve(true);
    return (react_1.default.createElement(Dialog_1.default, { open: isOpen, onClose: onClose, "aria-labelledby": "alert-dialog-title", "aria-describedby": "alert-dialog-description" },
        react_1.default.createElement(DialogTitle_1.default, { id: "alert-dialog-title" }, title !== null && title !== void 0 ? title : ""),
        react_1.default.createElement(DialogContent_1.default, null,
            react_1.default.createElement(DialogContentText_1.default, { id: "alert-dialog-description" }, text !== null && text !== void 0 ? text : "")),
        react_1.default.createElement(DialogActions_1.default, null,
            react_1.default.createElement(Button_1.default, { onClick: onClose, color: "primary" }, "Continue"))));
};
exports.alertDialog = react_modal_promise_1.create(Modal);
